/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';



export class DxoSliderMarkerComponent extends NestedOption {
    
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    
    get customizeText(): Function {
        return this._getOption('customizeText');
    }
    set customizeText(value: Function) {
        this._setOption('customizeText', value);
    }

    
    get font(): DevExpress.viz.Font {
        return this._getOption('font');
    }
    set font(value: DevExpress.viz.Font) {
        this._setOption('font', value);
    }

    
    get format(): DevExpress.ui.format|
        string {
        return this._getOption('format');
    }
    set format(value: DevExpress.ui.format|
        string) {
        this._setOption('format', value);
    }

    
    get invalidRangeColor(): string {
        return this._getOption('invalidRangeColor');
    }
    set invalidRangeColor(value: string) {
        this._setOption('invalidRangeColor', value);
    }

    
    get padding(): number {
        return this._getOption('padding');
    }
    set padding(value: number) {
        this._setOption('padding', value);
    }

    
    get paddingLeftRight(): number {
        return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value: number) {
        this._setOption('paddingLeftRight', value);
    }

    
    get paddingTopBottom(): number {
        return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value: number) {
        this._setOption('paddingTopBottom', value);
    }

    
    get placeholderHeight(): number {
        return this._getOption('placeholderHeight');
    }
    set placeholderHeight(value: number) {
        this._setOption('placeholderHeight', value);
    }

    
    get placeholderSize(): number|
        { height?: number, width?: number|
        { left?: number, right?: number } } {
        return this._getOption('placeholderSize');
    }
    set placeholderSize(value: number|
        { height?: number, width?: number|
        { left?: number, right?: number } }) {
        this._setOption('placeholderSize', value);
    }

    
    get precision(): number {
        return this._getOption('precision');
    }
    set precision(value: number) {
        this._setOption('precision', value);
    }

    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }

    protected get _optionPath() {
        return 'sliderMarker';
    }


    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-slider-marker',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'color': [{ type: Input },],
'customizeText': [{ type: Input },],
'font': [{ type: Input },],
'format': [{ type: Input },],
'invalidRangeColor': [{ type: Input },],
'padding': [{ type: Input },],
'paddingLeftRight': [{ type: Input },],
'paddingTopBottom': [{ type: Input },],
'placeholderHeight': [{ type: Input },],
'placeholderSize': [{ type: Input },],
'precision': [{ type: Input },],
'visible': [{ type: Input },],
};
}


export class DxoSliderMarkerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoSliderMarkerComponent
  ],
  exports: [
    DxoSliderMarkerComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
